import { useSession } from "@clerk/clerk-react";
import { Spinner, Tooltip } from "@heroui/react";
import { CloudCheck, CloudSlash } from "@phosphor-icons/react";
import { RentalContract } from "shared/types/rental-contracts";
import { syncProductsFromOdoo } from "./syncProductFromOdoo";
import { applyMask } from "shared/utils/masks";

interface RenderPriceProps {
  price: any;
  label: string;
  contract?: RentalContract;
  isArchived?: boolean;
  
  rentalInfo: {
    fetchRentalContracts: () => void;
    comparingOdoo: boolean;
    handleOpenPriceSyncModal: (price: any) => void;
  }
}

export const RenderPrice = (props: RenderPriceProps) => {
  const { price, label, contract, rentalInfo, isArchived = false } = props;
  const { session } = useSession();

    const shouldShowSyncButton = !isArchived && contract && (!contract.products?.length || contract.products.length === 0) && contract.odooContractId;
    
    if (!price && shouldShowSyncButton) {
      return <div className="flex gap-1.5">
        <span className="text-neutral-secondary">Geen producten gevonden</span>
        <Tooltip content={`Alle producten vanuit Odoo synchroniseren`}>
          <CloudSlash
            weight="duotone"
            size={20}
            className="cursor-pointer text-moss-primary"
            onClick={() => syncProductsFromOdoo(contract, session, rentalInfo.fetchRentalContracts)}
          />
        </Tooltip>
      </div>
    }
    
    if (!price) return <div className="flex gap-1.5"></div>

    const debugTooltip = (
      <div className="flex flex-col gap-1 text-xs">
        <div className="font-medium mb-1">Database IDs:</div>
        {price.odooOrderLineId && (
          <div>Odoo Order Line ID: <span className="font-mono">{price.odooOrderLineId}</span></div>
        )}
        {price.productId && (
          <div>YallyHub Product ID: <span className="font-mono">{price.productId}</span></div>
        )}
        {price.priceId && (
          <div>YallyHub Price ID: <span className="font-mono">{price.priceId}</span></div>
        )}
        {!price.odooOrderLineId && !price.productId && !price.priceId && (
          <div className="text-neutral-secondary">No database IDs available</div>
        )}
      </div>
    );

    return <div className="flex gap-1.5">
      <Tooltip content={debugTooltip}>
        <span className="cursor-help">{applyMask(price?.price, "valuta_specific")}</span>
      </Tooltip>
      {!isArchived && !rentalInfo.comparingOdoo && price?.equalsInOdoo !== undefined && (
        price.equalsInOdoo ? (
          <Tooltip content={`${label} in sync met Odoo`}>
            <CloudCheck weight="duotone" size={20} className="text-moss-primary" />
          </Tooltip>
        ) : (
          <Tooltip content={`${label} met Odoo synchroniseren`}>
            <CloudSlash
              weight="duotone"
              size={20}
              className="cursor-pointer text-brick-primary"
              onClick={() => rentalInfo.handleOpenPriceSyncModal(price)}
            />
          </Tooltip>
        )) || <Tooltip content={`Controle op synchronisatie met Odoo`}><Spinner color="warning" size="sm" /></Tooltip>}
    </div>
  }